import {z} from 'zod';

export const DataGridBulkActionsResponseBodySchema = z.object({
  resourceId: z.string().min(1),
  actions: z.array(
    z.object({
      actionCode: z.string().min(1),
      paramsSchema: z
        .object({
          root: z.object({
            elements: z.array(
              z.object({
                renderer: z.string(),
                name: z.string(),
                label: z.string().nullish(),
                defaultOptions: z
                  .array(
                    z.object({
                      value: z.string(),
                      label: z.string(),
                      isDisabled: z.boolean().optional(),
                    })
                  )
                  .nullish(),
              })
            ),
          }),
        })
        .nullish(),
    })
  ),
});
